var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-readlegalnotice",attrs:{"id":"app-readlegalnotice"}},[_c('myLegalNotice',{attrs:{"mln_id":'forreg',"mini-show":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }